import { slugs, pages } from '@kit/utils/APIV1'

export const routes = [
  {
    name: 'root',
    path: '/',
    component: () => import(/* webpackChunkName: "root" */'@pages/Home.vue'),
  },

  {
    name:"contact-us",
    path:"/contact-us",
    component: () => import(/* webpackChunkName: "contact-us" */'@pages/ContactUs.vue'),
  },

  {
    name: 'housing',
    path: '/housing',
    component: () => import(/* webpackChunkName: "housing" */'@pages/Housing.vue'),
  },

  {
    name: 'our-history',
    path: '/our-history',
    component: () => import(/* webpackChunkName: "our-history" */'@pages/History.vue'),
  },


  {
    name: 'about-us',
    path: '/about/about-us',
    component: () => import(/* webpackChunkName: "about-us" */'@pages/AboutUs.vue'),
  },

  {
    name: 'wellness-center',
    path: '/wellness-center',
    component: () => import(/* webpackChunkName: "wellness-center" */'@pages/WellnessCenter.vue'),
  },

  {
    name: 'careers',
    path: '/careers',
    component: () => import(/* webpackChunkName: "careers" */'@pages/FBICCCareers.vue'),
  },

  {
    name: 'job-post',
    path: '/job-post/:id',
    component: () => import(/* webpackChunkName: "job-post" */'@pages/JobPost.vue'),
    sitemap: {
      slugs: async() => {
        return await slugs('job-ids')
      }
    }
  },


  {
    name: 'calendar',
    path: '/calendar',
    component: () => import(/* webpackChunkName: "calendar" */ '@pages/MainCalendar.vue'),
  },

  {
    name:"government",
    path:"/government",
    component: () => import(/* webpackChunkName: "government" */'@pages/government/Government.vue'),
  },

  {
    name:"staff",
    path:"/staff",
    component: () => import(/* webpackChunkName: "staff" */'@pages/Staff.vue'),
  },

  {
    name:"forms",
    path:"/government/forms",
    component: () => import(/* webpackChunkName: "forms" */'@pages/government/DocumentsForms.vue'),
  },

  {
    name:"agendas",
    path:"/government/agendas/:page?/:b64SortInfo?",
    component: () => import(/* webpackChunkName: "agendas" */'@pages/government/Agendas.vue'),
    meta: {
      paramsMappedToMultipleSections: true,
      sitemap: {
        slugs: async() => {
          return await pages('agendas')
        }
      }

    }
  },

  {
    name:"minutes",
    path:"/government/minutes/:page?/:b64SortInfo?",
    component: () => import(/* webpackChunkName: "minutes" */'@pages/government/Minutes.vue'),
    meta: {
      paramsMappedToMultipleSections: true,
      sitemap: {
        slugs: async() => {
          return await pages('minutes')
        }
      }

    }
  },

  {
    name: 'news',
    path: '/news/:page?/:b64SortInfo?',
    component:() => import(/* webpackChunkName: "news" */'@pages/News.vue'),
    meta: {
      paramsMappedToMultipleSections:true,
      sitemap: {
        slugs: async() => {
          return await pages('news')
        }
      }
    }
  },

  {
    name: 'news-story',
    path: '/news-story/:slug',
    component:() => import(/* webpackChunkName: "news" */'@pages/NewsStory.vue'),
  },


]